(() => {
  const init = root => {
    for (const section of root.querySelectorAll('[data-gq-product]')) {
      const button = section.querySelector('[data-gq-personalize]');
      if (button.dataset.ready) continue;
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const status = section.querySelector('[data-gq-product-status]');
        button.disabled = true;
        status.textContent = '';
        try {
          await customElements.whenDefined('gravure-quote-studio');
          const studio = section.querySelector('gravure-quote-studio');
          if (!studio) throw Error('L’atelier doit être ajouté à cette fiche dans l’éditeur du thème.');
          const config = JSON.parse(studio.querySelector('[data-studio-config]').content.textContent);
          const support = config?.supports?.find(s => s.active && s.family === section.dataset.family && (section.dataset.kind === 'card' ? s.role === 'card' : s.role === 'keyring'));
          if (!support) throw Error('Ce support doit être activé et enregistré dans GravureQuote avant la personnalisation.');
          studio.dataset.productHandle = support.id;
          await studio.open();
          if (!studio.frame) throw Error(studio.querySelector('[data-status]')?.textContent || 'L’atelier n’a pas pu être ouvert. Réessayez.');
          const frame = studio.frame;
          const apply = () => {
            try {
              const w = frame.contentWindow;
              if (section.dataset.kind === 'card') {
                if (!w.GQCards?.apply) throw Error('Le modèle de carte n’a pas pu être chargé.');
                w.GQCards.apply(section.dataset.design);
              } else {
                if (!w.GQCreative?.applyPhotoTheme) throw Error('Le modèle de porte-clés n’a pas pu être chargé.');
                const input = w.document.getElementById('logo-file');
                const disabled = input.disabled;
                input.disabled = true;
                try { w.GQCreative.applyPhotoTheme(section.dataset.design); }
                finally { input.disabled = disabled; }
              }
            } catch (error) {
              studio.close();
              status.textContent = error.message;
              button.focus();
            }
          };
          if (frame.contentWindow?.GQCards?.apply && frame.contentWindow?.GQCreative?.applyPhotoTheme) apply();
          else frame.addEventListener('load', apply, {once:true});
        } catch (error) { status.textContent = error.message; }
        finally { button.disabled = false; }
      });
    }
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
